// Fancybox
{
  Fancybox.bind('[data-fancybox]', {
    // Custom options for all galleries
  });   
}

// Click to scroll Seciton
{
  function JumpSection(element) {
    let elementTop = element.offsetTop;
    let headerHeight = document.querySelector('.shopify-section--header').offsetHeight;
    console.log(element)
    Jump(element, {
      duration: 1500,
      offset: -headerHeight,
      callback: undefined,
      a11y: false
    });
    /*window.scrollTo({
      top: (elementTop - 80),
      behavior: "smooth",
    });*/
    window.sessionStorage.removeItem('sctollToSection');
  }
  let sctollToSection = window.sessionStorage.getItem('sctollToSection');
  if(sctollToSection){
    let element = (window.matchMedia('(max-width: 699px)').matches) ? (document.querySelector(`${sctollToSection}-mobile`) || document.querySelector(sctollToSection) ) : document.querySelector(sctollToSection);
    if(element) JumpSection(element);
  }
  document.querySelectorAll('[data-scroll-section]').forEach(button => {
    button.addEventListener('click',function(event) {
      event.preventDefault();
      let newURL = new URL(button.href);
      let section = (window.matchMedia('(max-width: 699px)').matches) ? (document.querySelector(`${newURL.hash}-mobile`) || document.querySelector(newURL.hash) ) : document.querySelector(newURL.hash);
      let currentPage = window.location;
      if(newURL.pathname == currentPage.pathname){
        if(section){
          if(this.closest('details[is=mega-menu-disclosure]')){
            this.closest('details[is=mega-menu-disclosure]').querySelector('summary').click();
          }
          if(this.closest('navigation-drawer')) this.closest('navigation-drawer').removeAttribute('open');
          JumpSection(section);
        }else{
          window.location.href = newURL.pathname;
        }
      }else{
        window.sessionStorage.setItem('sctollToSection',newURL.hash);
        window.location.href = newURL.pathname; 
      }
    });
  })
}